export const calculatePriceContainerMargins = (offerPriceHeight: number, pricePerMonthHeight: number) => {
  if (offerPriceHeight > pricePerMonthHeight) {
    return {
      computedPricePerMonthMargin: offerPriceHeight - pricePerMonthHeight,
      priceTitleSizeHighest: offerPriceHeight
    }
  }

  return {
    computedPricePerMonthMargin: pricePerMonthHeight - offerPriceHeight,
    priceTitleSizeHighest: pricePerMonthHeight
  }
}

export const findHighestElementsHeight = (elements: HTMLElement[]) => {
  const heights: number[] = elements.map(element => element.offsetHeight)
  return Math.max(...heights)
}
